

import baseClass from "./base";

window.addEventListener("popstate", function (event) {
  baseClass.processPopState(event);
});

$(window).on("load", function (e) {
  baseClass.OnLoadAll();
  baseClass.OnReadyAll();
});

